exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.notification-item[data-v-4d4cbf64]{\n  font-size: 0.8rem\n}\n", ""]);

// exports
